import React, { useState, useEffect } from 'react';
import styles from './minSliderCard.module.css';

import { useDbUserId } from '../../../hooks/useDbUserId';

import {
	useAddWishlistMutation,
	useDeleteWishlistItemMutation,
	useGetUserWishlistQuery,
} from '../../../store/api/wishlist.api';

import { BlueBtn } from '../../../UI/BlueBtn/BlueBtn';
import { Link } from 'react-router-dom';
import { LazyImage } from '../../LazyImage/LazyImage'

import likeIcon from '../../../assets/like-icon.svg';
import blueLikeIcon from '../../../assets/like_blue-icon.svg';

export const MinSliderCard = ({
	buyBtn,
	transactionId,
	title,
	description,
	login,
	price,
	price_disc,
	devices,
	lang,
	img,
	itemId,
	subCategory,
	subscriptionId,
	subTime,
	style,
	editionItemId,
	editionTitle,
	from,
	disabledLink
}) => {
	const schema = window.sessionStorage.getItem('schema');

	const { dbUserId, isLoading } = useDbUserId();
	const [addItemToWishlist] = useAddWishlistMutation();
	const [deleteItemFromWishlist] = useDeleteWishlistItemMutation();

	const { data, refetch } = useGetUserWishlistQuery(
		{ userId: dbUserId, schema },
		{ skip: isLoading || !dbUserId }
	);

	const itemInWishlist = data?.items?.some((item) =>
		itemId ? item.itemId === itemId : item.subscriptionId === subscriptionId
	);

	const [inWishlist, setInWishlist] = useState(false);

	useEffect(() => {
		setInWishlist(itemInWishlist);
	}, [itemInWishlist]);

	const toggleWishlist = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		if (!dbUserId) return;

		try {
			if (inWishlist) {
				await deleteItemFromWishlist({
					data: { userId: dbUserId, itemId, subscriptionId },
					schema,
				});
				setInWishlist(false);
			} else {
				await addItemToWishlist({
					data: { userId: dbUserId, itemId, subscriptionId },
					schema,
				});
				setInWishlist(true);
			}

			await refetch();
		} catch (error) {
			console.error('Ошибка при изменении wishlist:', error);
		}
	};

	const showLink = ((itemId && !subscriptionId) || (editionItemId && !subscriptionId)) && !disabledLink;
	const cardLink = showLink ? `/items/${itemId || editionItemId}` : '#';

	return (
		<div className={`${styles.main} ${from ? styles.forCatalog : ''}`} style={style}>
			<Link to={schema !== "PS_sharing" ? cardLink : `/PS_sharing/items/${itemId}`}>
				<div
					className={styles.img_block}
				>
					<LazyImage src={img} alt={title}/>
					{
						schema !== 'steam' && schema !== 'xbox' &&
							<img
								className={styles.likeIcon}
								src={inWishlist ? blueLikeIcon : likeIcon}
								alt="wishlist icon"
								width={20}
								height={17}
								onClick={toggleWishlist}
						/>
					}
				</div>

				<div className={styles.description_block}>
					<div>
						<h3>{subCategory ? `${title} ${subCategory}` : title}</h3>
						{description && <h3 style={{marginTop: 3}}>{description}</h3>}
						<div className={styles.editionTitle}>{editionTitle && editionTitle}</div>
						{
							price ?
							<p className={styles.price}>
								{
									price_disc &&
									<span className={styles.price_disc} style={{color: 'red'}}>{price_disc}₽</span>
								}
								<span className={!price_disc ? styles.price_amount : styles.price_amount_discount}>
									{price} ₽
								</span>
							</p>
							:
							<>
								<p className={styles.login}>{login}</p>
								<p className={styles.login}>{transactionId}</p>
							</>
						}
						
					</div>

					<div className={styles.about}>
						<p className={styles.device}>
							<span>{devices?.map((device) => device.name || device.title).join(', ')}</span>
						</p>
						<p className={styles.lang}>{lang}</p>
						<p>{subTime && `На ${subTime}`}</p>
					</div>
					
				</div>
			</Link>

			{buyBtn && (
				<div className={styles.buyBtn}>
					<BlueBtn
						type={'main'}
						itemId={itemId}
						subscriptionId={subscriptionId}
					/>
				</div>
			)}
		</div>
	);
};
